import { LmsRoleAccess, LmsRole } from './type';

export const getAccessObject = async (role: LmsRole): Promise<LmsRoleAccess> => {
	const json = await import(`../../config/lmsRoleAccess/${role}.json`);
	return json.default as LmsRoleAccess;
};
